export const getPartitionedKey = (key) => {
    if (window.Office && Office.context && Office.context.partitionKey) {
        return `${Office.context.partitionKey}_${key}`;
    }
    return key;
};

export const getPartitionedLocalStorage = (key) => {
    return localStorage.getItem(getPartitionedKey(key));
};

export const setPartitionedLocalStorage = (key, value) => {
    localStorage.setItem(getPartitionedKey(key), value);
};